/**
 * TypeBox schemas for Origin type — provenance tracking for entities.
 */

import { Type, type Static } from 'typebox'
import { UUID, type Exact } from './common.js'

export const OriginUserCreatedSchema = Type.Object({
  type: Type.Literal('user-created'),
})

export const OriginImportedSchema = Type.Object({
  type: Type.Literal('imported'),
  source: Type.Union([
    Type.Literal('gpx'),
    Type.Literal('kml'),
    Type.Literal('kmz'),
    Type.Literal('geojson'),
    Type.Literal('alltrails'),
    Type.Literal('cotrex'),
    Type.Literal('osm'),
  ]),
})

export const OriginDerivedSchema = Type.Object({
  type: Type.Literal('derived'),
  entityType: Type.Union([Type.Literal('route'), Type.Literal('plan'), Type.Literal('activity')]),
  entityId: UUID,
})

export const OriginSchema = Type.Union([
  OriginUserCreatedSchema,
  OriginImportedSchema,
  OriginDerivedSchema,
])
export type Origin = Exact<Static<typeof OriginSchema>>
